// @module NVT.membershipdirectoryProfile
define('membershipdirectoryProfile.View'
,	[
		'membershipdirectory_profile.tpl'
		
	,	'Backbone'

    ]
, function (
		membershipdirectory_profile_tpl
		
	,	Backbone

)
{
    'use strict';

	// @class NVT.membershipdirectoryProfile.View @extends Backbone.View
	return Backbone.View.extend({

		template: membershipdirectory_profile_tpl

	,	initialize: function (options) {
			this.options = options;
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');
			var self = this;
		}

	,	bindings: {

		}

	, 	childViews: {

		}

		//@method getContext @return NVT.membershipdirectoryProfile.View.Context
	,	getContext: function getContext()
		{
			var self = this;		

			return {
				getcompanyprofile :  this.options.getcompanyprofile || '' ,		

				redirectUrl :  this.options.redirectUrl || '' ,				

				image :  this.options.image || '' ,		
				
				uenno : this.options.uenno || '' ,

				compname : this.options.compname || '' ,

				memStatus : this.options.memStatus || '' ,

			}
		}
	});
});
